import { useEffect } from 'react';
import {
  NavLink,
  Outlet,
  useParams,
  generatePath,
  useNavigate,
  useMatch,
  useLocation,
} from 'react-router-dom';
import { IconArrowLeft } from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import { getUser, getCards, clearCardItemState } from './store/slices/item';
import { CardsRoutes } from '../../routes';
import { useLazyGetCustomersQuery } from './store/services';

import cn from './cards.module.css';

const CardInfo = () => {
  const {
    item: { cards, user },
    list: { customers },
  } = useAppSelector((state) => state.cards);

  const match = useMatch(CardsRoutes.CARD_INFO_TRANSACTION_INFO);

  const { cardId, id, transactionId } = useParams();
  const { search } = useLocation();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [getCustomers] = useLazyGetCustomersQuery();

  useEffect(() => {
    if (cardId) {
      dispatch(getUser(cardId));
      dispatch(getCards());
    }
  }, [dispatch, cardId]);

  useEffect(() => {
    if (!customers) {
      getCustomers();
    }
  }, [customers]);

  useEffect(() => {
    if (cards.values) {
      if (
        match &&
        transactionId &&
        transactionId !== 'order' &&
        transactionId !== 'edit'
      ) {
        navigate(
          generatePath(
            `${CardsRoutes.CARD_INFO_TRANSACTION_INFO}${search || ''}`,
            { cardId: cardId as string, id: id as string, transactionId },
          ),
        );
      } else {
        navigate(
          generatePath(`${CardsRoutes.CARD_INFO_TRANSACTIONS}${search || ''}`, {
            cardId: cardId as string,
            id: id || cards.values[0].id,
          }),
        );
      }
    }
  }, [cards, search]);

  useEffect(() => {
    let title =
      user?.firstName || user?.lastName
        ? `Cards: ${user?.firstName || ''} ${user?.lastName || ''}`
        : 'Cards';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, [user?.firstName, user?.lastName]);

  return (
    <div className={cn.cardItemPage}>
      <div className={cn.cardItemPageContent}>
        <div className={cn.cardItemPageLinkWrapper}>
          <NavLink
            to={CardsRoutes.CARDS_LIST}
            className={cn.cardItemPageBackLink}
            onClick={() => dispatch(clearCardItemState())}
          >
            <IconArrowLeft width={13} height={11} />
            Back to Cards
          </NavLink>
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default CardInfo;
